// latest: zhangmyh 2017-3-17 9:14 AM
import { Model } from 'common'

Model.define('evalapply.evaorg', {
  meta: {
    id: '',
    evaOrgId: '',
    evaOrgName: '',
    evaOrgPsnId: '',
    evaOrgPsnName: '',
    status: ''
  }
})



// WEBPACK FOOTER //
// ./src/data/model/evaluationApply/evaOrg.js